const initialProps = {
  ticketFiveDetalle: [],
};

export default function (state = initialProps, action) {
  switch (action.type) {
    case "CREATE_TICKET_FIVE_DETALLE":
      return {
        ...state,
        ticketFiveDetalle: [...state.ticketFiveDetalle, action.payload],
      };
    case "UPDATE_TICKET_FIVE_DETALLE":
      return {
        ...state,
        ticketFiveDetalle: action.payload,
      };
    case "REMOVE_TICKET_FIVE_DETALLE":
      return {
        ...state,
        ticketFiveDetalle: action.payload,
      };
    default:
      return state;
  }
}
